/* Prices come from the existing visualizer catalog, never from saved drafts. */
function papasBookingSummaryLines(design) {
  const details = design.lineItems ? design.lineItems.map(item => `${item.name} (${item.price})`) : design.details;
  return [
    'Garment:',
    `-${design.garment}${design.basePrice ? ` (${design.basePrice})` : ''}`,
    'Details:',
    ...(details.length ? details.map(detail => `-${detail}`) : ['-No details added']),
    '',
    `Estimated total: ${design.estimate}`
  ];
}

/* Public garment choices only. Never put customer contact details in the URL. */
function buildPapasBookingLink(design, includeDesign) {
  const url = new URL('https://calendly.com/papasdenimbar/appointment');
  if (includeDesign) {
    const brief = ["Papa's Denim Bar — design reference", ...papasBookingSummaryLines(design), 'Price subject to confirmation at fitting.', 'Visualizer reference only; final garment, fit and details agreed at the appointment.'].join('\n');
    // Current form: product, size, garment source, then design brief.
    url.searchParams.set('a4', brief);
    // Verified Q1 checkbox positions: jacket first, shirt second.
    url.searchParams.set('a1', design.garment === 'Denim jacket' ? '1' : '2');
  }
  return url.href;
}

/* An addressable local route shares the existing visualizer's validated draft. */
function createPapasBookingPage(getDesign) {
  const page = document.getElementById('booking-page');
  const shell = document.querySelector('.site-shell');
  const include = document.getElementById('include-design');
  const summary = document.getElementById('booking-summary');
  const fallback = document.getElementById('calendly-continue');
  const host = document.getElementById('calendly-embed');
  const load = document.getElementById('load-calendar');
  const status = document.getElementById('calendar-status');
  const complete = document.getElementById('calendar-complete');
  let scriptPromise, cancelScript, timer, generation = 0, trigger;
  try { include.checked = sessionStorage.getItem('papas-booking-include') !== 'false'; } catch {}
  function updateSummary() {
    const design = getDesign();
    document.getElementById('booking-item-lines').textContent = papasBookingSummaryLines(design).slice(0,-2).join('\n');
    document.getElementById('booking-total-value').textContent = design.estimate;
    summary.hidden = !include.checked;
    document.getElementById('design-sharing-note').textContent = include.checked ? 'Your design is a starting point. Price and fit confirmed at your visit.' : 'Your design stays here. No design details will be sent to Calendly.';
    fallback.href = buildPapasBookingLink(design, include.checked);
  }
  function resetCalendar(message) {
    generation++; clearTimeout(timer); cancelScript?.(); host.replaceChildren(); host.hidden = true;
    complete.hidden = true; include.disabled = false; load.hidden = false; load.disabled = false;
    status.textContent = message; host.setAttribute('aria-busy', 'false');
  }
  function widgetScript() {
    if (window.Calendly) return Promise.resolve();
    if (!scriptPromise) scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      cancelScript = () => {
        script.onload = script.onerror = null; script.remove(); scriptPromise = null;
        cancelScript = null; reject(new Error('Widget cancelled'));
      };
      script.src = 'https://assets.calendly.com/assets/external/widget.js'; script.async = true;
      script.onload = () => {
        if (window.Calendly) { cancelScript = null; resolve(); }
        else { cancelScript(); }
      };
      script.onerror = () => cancelScript?.();
      document.head.append(script);
    });
    return scriptPromise;
  }
  async function loadCalendar() {
    const attempt = ++generation;
    cancelScript?.();
    clearTimeout(timer);
    host.replaceChildren(); host.hidden = true;
    host.setAttribute('data-state', 'loading'); host.setAttribute('aria-hidden', 'false');
    load.hidden = true; load.disabled = true; status.textContent = 'Loading available times…';
    host.setAttribute('aria-busy', 'true');
    timer = setTimeout(() => {
      if (attempt !== generation) return;
      status.textContent = 'Calendly is taking longer than usual. You can open Calendly directly, or keep waiting here.';
      host.setAttribute('data-state','slow');
      load.disabled = false; load.hidden = false; load.textContent = 'Try calendar again';
    }, 15000);
    try {
      await widgetScript();
      if (attempt !== generation || page.hidden) return;
      host.replaceChildren(); host.hidden = false; host.style.height = '760px';
      host.setAttribute('data-stage','widget-ready');
      const url = new URL(fallback.href);
      // Use the same populated URL as the direct link. Removing these answers
      // before widget initialization was dropping the design from the iframe.
      url.searchParams.set('hide_event_type_details','1');
      window.Calendly.initInlineWidget({url:url.href.replaceAll('+','%20'), parentElement:host, resize:true});
      const frame = host.querySelector('iframe');
      if (frame) {
        frame.title = 'Book your Papa’s Denim Bar appointment';
        frame.addEventListener('load', () => { if (attempt === generation) host.setAttribute('data-stage','frame-loaded'); });
      }
    } catch {
      if (attempt !== generation) return;
      clearTimeout(timer); host.hidden = true; host.setAttribute('aria-busy','false');
      status.textContent = 'The calendar could not load. Try again or open Calendly directly.';
      load.hidden = false; load.disabled = false; load.textContent = 'Try calendar again';
    }
  }
  load.addEventListener('click', loadCalendar);
  window.addEventListener('message', event => {
    const frame = host.querySelector('iframe');
    if (page.hidden || !frame || event.origin !== 'https://calendly.com' || event.source !== frame.contentWindow) return;
    const name = event.data?.event;
    if (!['calendly.event_type_viewed','calendly.date_and_time_selected','calendly.event_scheduled'].includes(name)) return;
    clearTimeout(timer); host.setAttribute('data-stage','calendar-ready'); host.hidden = false; host.setAttribute('data-state','ready'); host.setAttribute('aria-hidden','false'); host.setAttribute('aria-busy','false'); load.hidden = true;
    status.textContent = name === 'calendly.date_and_time_selected' ? 'Finish your details below to book.' : 'Choose your date and time below.';
    if (name === 'calendly.event_scheduled') {
      complete.hidden = false; status.textContent = ''; include.disabled = true;
    }
  });
  include.addEventListener('change', () => {
    try { sessionStorage.setItem('papas-booking-include', String(include.checked)); } catch {}
    updateSummary();
    resetCalendar('Design preference updated. Loading your updated design; choose your time again if needed.');
    if (!page.hidden) loadCalendar();
  });
  function route() {
    const active = location.hash === '#book';
    page.hidden = !active; shell.hidden = active;
    document.body.classList.toggle('booking-active', active);
    if (active) {
      updateSummary(); document.title = 'Book a visit — Papa’s Denim Bar';
      if (!host.querySelector('iframe') && !load.disabled) loadCalendar();
      window.scrollTo({top:0, behavior:'instant'}); document.getElementById('booking-title').focus({preventScroll:true});
    } else {
      resetCalendar('The calendar loads when you’re ready.'); document.title = 'Papa’s Denim Bar — Custom Studio';
      if (trigger?.isConnected) trigger.focus({preventScroll:true});
    }
  }
  for (const id of ['book-button','header-book']) document.getElementById(id).addEventListener('click', event => {
    trigger = event.currentTarget; location.hash = 'book';
  });
  window.addEventListener('hashchange', route);
  window.addEventListener('pageshow', updateSummary);
  route();
}
